import { useId } from 'react'
import { cn } from '@/lib/cn'

interface ToggleFieldProps {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  hint?: string
}

/** An on/off setting in a form: a switch beside its label, a hint below. */
export function ToggleField({ label, checked, onChange, hint }: ToggleFieldProps) {
  const id = useId()
  return (
    <div className="field-row">
      <div className="field toggle-field">
        <button
          type="button"
          role="switch"
          id={id}
          aria-checked={checked}
          aria-describedby={hint ? `${id}-hint` : undefined}
          className={cn('toggle-switch', checked && 'is-on')}
          onClick={() => onChange(!checked)}
        >
          <span className="toggle-switch-knob" aria-hidden="true" />
        </button>
        {/* A label activates the button it names, so clicking the text toggles too. */}
        <label className="toggle-field-label" htmlFor={id}>
          {label}
        </label>
        {hint ? (
          <div className="field-hint toggle-field-hint" id={`${id}-hint`}>
            {hint}
          </div>
        ) : null}
      </div>
    </div>
  )
}
